import React from 'react';
import formatMessage from 'format-message';
import Link from '../common/link';
import { URLS } from '../../common/urls';
import { IconExternalLinkLine } from '@instructure/ui-icons';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';

export default function () {
  return (
    <footer className="App-footer" data-testid="AppFooter">
      <Link
        href="/tos"
        target="_blank"
        iconPlacement="end"
        renderIcon={<IconExternalLinkLine size="x-small" />}
      >
        {formatMessage('Terms of Use')}
        <ScreenReaderContent>{formatMessage('- Opens in a new tab.')}</ScreenReaderContent>
      </Link>
      <Link
        href={URLS.privacy}
        target="_blank"
        iconPlacement="end"
        renderIcon={<IconExternalLinkLine size="x-small" />}
      >
        {formatMessage('Privacy Policy')}
        <ScreenReaderContent>{formatMessage('- Opens in a new tab.')}</ScreenReaderContent>
      </Link>
      <Link
        href={URLS.what_is_canvas_commons}
        target="_blank"
        iconPlacement="end"
        renderIcon={<IconExternalLinkLine size="x-small" />}
      >
        {formatMessage('Help')}
        <ScreenReaderContent>{formatMessage('- Opens in a new tab.')}</ScreenReaderContent>
      </Link>
    </footer>
  );
}
